import { useState } from 'react';

export interface Checklist<T> {
  checklist: T[];
  setChecklist: React.Dispatch<React.SetStateAction<T[]>>;
  toggle: (item: T) => void;
  checked: (item: T) => boolean;
  setChecked: (item: T, checked: boolean) => void;
  allCheckedAndNotEmpty: boolean;
  checkAll: () => void;
  toggleCheckAll: () => void;
}

export function useChecklist<T>(initial: T[] = [], allItems: T[] = []): Checklist<T> {
  const [checklist, setChecklist] = useState(initial);

  const allCheckedAndNotEmpty =
    checklist.length > 0 && allItems.every((c) => checklist.includes(c));

  return {
    checklist,
    setChecklist,
    toggle(item: T) {
      setChecklist((checklist) => {
        if (checklist.includes(item)) {
          return checklist.filter((i) => i !== item);
        } else {
          return [...checklist, item];
        }
      });
    },
    checked(item: T) {
      return checklist.includes(item);
    },
    setChecked(item: T, checked: boolean) {
      setChecklist((checklist) => {
        if (checked) {
          if (!checklist.includes(item)) {
            return [...checklist, item];
          }
          return checklist;
        } else {
          return checklist.filter((i) => i !== item);
        }
      });
    },
    allCheckedAndNotEmpty,
    checkAll() {
      setChecklist(allItems);
    },
    toggleCheckAll() {
      if (allCheckedAndNotEmpty) {
        setChecklist([]);
      } else {
        setChecklist(allItems);
      }
    },
  };
}
